import React, { useEffect } from "react";
import { Accordion, Banner } from "flowbite-react";
import { Link } from "react-router-dom";
import { useEsop } from "../context/EsopContextHelper";
import { useWidget } from "../context/WidgetContextHelper";

const EsopPage = () => {
  const { accordions, getAllAccordions } = useEsop();
  const { esopWidget, getEsopWidget } = useWidget();
  useEffect(() => {
    (async () => {
      await getAllAccordions();
      await getEsopWidget();
    })();
  }, []);

  return (
    <div className="flex flex-col justify-between items-center">
      <Banner className="w-full mb-8">
        <div className="flex flex-col top-20 justify-between border border-gray-200 rounded-md p-4 mb-4 lg:flex-row lg:h-72 bg-white shadow-md">
          <div className="mb-4 md:mb-0 md:mr-4 flex flex-col order-2 md:order-1">
            <h2 className="mb-1 text-gray-900 text-3xl md:text-5xl font-bold tracking-tight">
              ESOP Plan Design
            </h2>
            <div className="py-2">
              {esopWidget &&
                esopWidget.content
                  .split("\n")
                  .filter((row) => row.trim() !== "")
                  .map((row, index) => (
                    <p
                      key={index}
                      className="text-md font-medium text-gray-500 w-full text-justify tracking-tighter py-1"
                    >
                      {row}
                    </p>
                  ))}
            </div>
          </div>
          <div className="flex h-2/4 md:h-full md:flex-row order-1 md:order-2 items-center mb-2 md:w-2/4">
            <img
              src={process.env.PUBLIC_URL + "/Esop Banner.jpeg"}
              alt="Banner Image"
              className="w-full h-full object-contain rounded-md"
            />
          </div>
        </div>
      </Banner>
      <div className="w-full">
        <Accordion
          theme={{
            root: {
              base: "divide-y divide-gray-200 border-gray-200 dark:divide-gray-700 dark:border-gray-700",
              flush: {
                off: "rounded-md border",
                on: "border-b",
              },
            },
            content: {
              base: "py-5 px-5 last:rounded-b-md dark:bg-gray-900 first:rounded-t-md",
            },
            title: {
              arrow: {
                base: "h-6 w-6 shrink-0",
                open: {
                  off: "",
                  on: "rotate-180",
                },
              },
              base: "flex w-full items-center justify-between first:rounded-t-md last:rounded-b-md py-5 px-5 text-left font-sm text-gray-500 dark:text-gray-400",
              flush: {
                off: "hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 dark:hover:bg-gray-800 dark:focus:ring-gray-800",
                on: "bg-transparent dark:bg-transparent",
              },
              heading: "",
              open: {
                off: "",
                on: "text-gray-900 bg-gray-100 dark:bg-gray-800 dark:text-white",
              },
            },
          }}
        >
          {accordions.map((accordion) => {
            return (
              <Accordion.Panel key={accordion.id}>
                <Accordion.Title
                  theme={{
                    base: "flex w-full items-center justify-between first:rounded-t-md last:rounded-b-md py-5 px-5 text-left font-semibold text-xl text-gray-500 dark:text-gray-400",
                  }}
                >
                  {accordion.title}
                </Accordion.Title>
                <Accordion.Content>
                  <p className="mb-2 text-gray-800 font-medium text-lg dark:text-gray-400 text-justify">
                    {accordion.description}
                  </p>
                  <li className="text-lg">
                    <a
                      href={accordion.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-lg text-cyan-600 hover:underline dark:text-cyan-500"
                    >
                      {accordion.link}
                    </a>
                  </li>
                  <div className="grid gap-6 grid-cols-1 lg:grid-cols-5 p-4">
                    {accordion.options.map((option) => {
                      return (
                        option.is_active && (
                          <div
                            className="flex items-center ps-4 border border-gray-200 rounded dark:border-gray-700"
                            key={option.id}
                          >
                            {option.text.toLowerCase() === "other" ? (
                              <>
                                <input
                                  type="text"
                                  placeholder={option.text}
                                  className="bg-gray-100 border-none git text-gray-900 sm:text-sm rounded-md focus:ring-[#003464] focus:border-[#003464] block w-full p-2.5 me-4"
                                />
                              </>
                            ) : (
                              <>
                                <input
                                  id={option.id}
                                  type="radio"
                                  value={option.text}
                                  name={`accordion-radio-${accordion.id}`}
                                  className="w-4 h-4 text-[#003464] bg-gray-100 border-gray-300 focus:ring-[#003464] dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                />
                                <label
                                  htmlFor={option.id}
                                  className="w-full p-4 ms-2 text-md font-medium text-gray-800 dark:text-gray-300"
                                >
                                  {option.text}
                                </label>
                              </>
                            )}
                          </div>
                        )
                      );
                    })}
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            );
          })}
        </Accordion>
      </div>
      {/* <div>Button</div> */}
    </div>
  );
};

export default EsopPage;
